import React from 'react';
import { Grid } from '@mui/material';

interface ISectionDividerProps {
  isVisible: boolean;
  dividerClasses: string;
}

const SectionDivider: React.FC<ISectionDividerProps> = ({ isVisible, dividerClasses }) => {
  if (!isVisible) return null;

  return (
    <Grid item xs={12}>
      <div className={dividerClasses} />
    </Grid>
  );
};

export default SectionDivider;
